import { useMutation } from "react-query";

import { updateClinicianProfileAsync } from "api/clinician";
import { useGlobalToast } from "components/GlobalToastProvider";

const useUpdateClinicianProfile = (options = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading } = useMutation((payload) => updateClinicianProfileAsync(payload), {
    onError: () => {
      showToast({
        message: "Error updating the clinician",
        errorState: true,
      });
      onError();
    },
    ...otherOptions,
  });

  return {
    updateClinicianProfile: mutate,
    isUpdateClinicianLoading: isLoading,
  };
};

export default useUpdateClinicianProfile;
